<ion-content class="login-page">
    <div class="content-column">
      <div class="content-wrapper">
        <h1>Sell Smarter with <span>SmartSell</span></h1>
        <p class="subtitle">Join thousands of sellers growing their business with our powerful e-commerce platform</p>
        
        <div class="benefits-container">
          <div class="benefit-item">
            <ion-icon name="rocket-outline"></ion-icon>
            <div>
              <h3>Quick Setup</h3>
              <p>Get your store up and running in minutes</p>
            </div>
          </div>
          
          <div class="benefit-item">
            <ion-icon name="analytics-outline"></ion-icon>
            <div>
              <h3>Powerful Analytics</h3>
              <p>Track your sales and customer behavior</p>
            </div>
          </div>
          
          <div class="benefit-item">
            <ion-icon name="shield-checkmark-outline"></ion-icon>
            <div>
              <h3>Secure Payments</h3>
              <p>Multiple payment options with 100% security</p>
            </div>
          </div>
        </div>
        
        <div class="testimonial">
          <div class="quote">"SmartSell helped me grow my business by 300% in just 6 months!"</div>
          <div class="author">- Priya K., Fashion Boutique Owner</div>
        </div>
      </div>
      <div class="login-column">
        <div class="login-container">
          <ion-card class="login-card">
            <ion-card-header>
              <div class="logo-container">
                <img src="../../../assets/new-images/seller-store-new-logo.svg" alt="SmartSell Logo">
                <h1>Welcome to SmartSell</h1>
              </div>
              <p class="subtitle">
                <span *ngIf="regsistrationType === 'login'">
                  Login to your seller account
                </span>
                <span *ngIf="regsistrationType === 'register'">
                  Start your selling journey today
                </span>
              </p>
              <div class="header-decoration">
                <div class="decoration-line"></div>
                <ion-icon name="storefront-outline"></ion-icon>
                <div class="decoration-line"></div>
              </div>
            </ion-card-header>
  
            <ion-card-content>
              <!-- Phone Input Section -->
              <div class="phone-section" *ngIf="!otpSent">
                <form [formGroup]="phoneForm" (ngSubmit)="sendOTP()">
                  <ion-item lines="none" class="input-item">
                    <div slot="start" class="country-code">+91</div>
                    <ion-input 
                      type="tel"
                      formControlName="phoneNumber"
                      placeholder="Enter mobile number"
                      maxlength="10">
                    </ion-input>
                  </ion-item>
                  
                  <ion-note color="danger" *ngIf="phoneForm.get('phoneNumber')?.touched && phoneForm.get('phoneNumber')?.errors">
                    Please enter a valid 10-digit mobile number
                  </ion-note>
  
                  <ion-button 
                    type="submit"
                    expand="block"
                    class="primary-button"
                    [disabled]="!phoneForm.valid">
                    Send OTP
                    <ion-icon name="arrow-forward" slot="end"></ion-icon>
                  </ion-button>
                </form>
  
                <div class="divider">
                  <span>or</span>
                </div>
  
                <ion-button expand="block" fill="outline" class="secondary-button" (click)="signinWithSamhita()">
                  <!-- <ion-icon name="mail" slot="start"></ion-icon> -->
                  <img height="30" width="30" style="margin-right: 10px;" src="../../../assets/new-images/samita_small_logo.svg" alt=""> Continue with Samhita
                </ion-button>
              </div>
  
              <!-- OTP Verification Section -->
              <div class="otp-section" *ngIf="otpSent">
                <div class="otp-header">
                  <h2>Verify OTP</h2>
                  <p>Enter the 6-digit code sent to <strong>+91 {{phoneForm.get('phoneNumber')?.value}}</strong></p>
                </div>
  
                <div class="otp-inputs">
                  <ion-input 
                    *ngFor="let _ of [1,2,3,4,5,6]; let i = index"
                    #otpInput
                    type="tel"
                    maxlength="1"
                    [(ngModel)]="otpDigits[i]"
                    (ionInput)="onOtpInput($event, i)"
                    (keydown)="onKeyDown($event, i)">
                  </ion-input>
                </div>
  
                <div class="timer" *ngIf="!canResend">
                  <ion-icon name="time-outline"></ion-icon>
                  <span>Resend OTP in {{timeLeft}} seconds</span>
                </div>
  
                <ion-button 
                  expand="block" 
                  class="primary-button" 
                  [disabled]="!isValidOtp"
                  (click)="verifyOTP()">
                  Verify & Continue
                </ion-button>
  
                <div class="footer-links">
                  <a *ngIf="canResend" (click)="resendOTP()">Resend OTP</a>
                  <a (click)="changeNumber()">Change Number</a>
                </div>
              </div>
            </ion-card-content>
            <p *ngIf="regsistrationType === 'login'" style="text-align: center;margin: 0 0 20px 0;cursor: pointer;">Don't have an account? <a (click)="register()">Sign up</a></p>
            <p *ngIf="regsistrationType === 'register'" style="text-align: center;margin: 0 0 20px 0;cursor: pointer;">Already have an account? <a (click)="login()">Sign in</a></p>
          </ion-card>
        </div>
      </div>
    </div>
  
</ion-content>